import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import * as React from 'react';
import { isVolumeValueCheck, getVolumeNewValue } from './helpers';
import { IconMuted } from './assets/mute';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var style = require('./VideoTemplate.css');
var SOUND_STEP = 0.2;
var SOUND_CHANGE_INTERVAL = 350;
export var VideoTemplate = /*#__PURE__*/function (_React$Component) {
  function VideoTemplate(props) {
    var _this;
    _classCallCheck(this, VideoTemplate);
    _this = _callSuper(this, VideoTemplate, [props]);
    _defineProperty(_this, "video", null);
    _defineProperty(_this, "soundTimer", undefined);
    _defineProperty(_this, "muteChange", function () {
      if (_this.video) {
        _this.video.muted = !_this.video.muted;
        _this.setState({
          isMute: !_this.state.isMute
        }, function () {
          _this.handleSoundChange(_this.state.isMute ? 'down' : 'up');
        });
      }
    });
    _defineProperty(_this, "handleSoundChange", function (type) {
      clearTimeout(_this.soundTimer);
      var _tick = function tick() {
        if (_this.video) {
          var volume = _this.video.volume;
          if (isVolumeValueCheck(type, _this.video.volume)) {
            _this.video.volume = getVolumeNewValue(type, volume, SOUND_STEP);
            _this.soundTimer = window.setTimeout(_tick, SOUND_CHANGE_INTERVAL);
          } else {
            clearTimeout(_this.soundTimer);
          }
        }
      };
      _this.soundTimer = window.setTimeout(_tick, SOUND_CHANGE_INTERVAL);
    });
    _defineProperty(_this, "handleClose", function () {
      _this.setState({
        isVisible: false
      });
    });
    _defineProperty(_this, "handleVideoEnd", function () {
      _this.setState({
        isPlay: false
      });
    });
    _this.state = {
      isMute: true,
      isPlay: true,
      isVisible: true
    };
    return _this;
  }
  _inherits(VideoTemplate, _React$Component);
  return _createClass(VideoTemplate, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.video) {
        this.video.volume = 0;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.soundTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      if (!this.state.isVisible) {
        return null;
      }
      return /*#__PURE__*/_jsxs("div", {
        className: style['video-container'],
        children: [!this.state.isPlay && /*#__PURE__*/_jsxs("div", {
          className: style['buttons-container'],
          children: [/*#__PURE__*/_jsx("div", {
            className: style['button-restart'],
            onClick: function onClick() {
              return _this2.handleReplayClick();
            },
            children: "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0435\u0449\u0435 \u0440\u0430\u0437"
          }), /*#__PURE__*/_jsx("div", {
            className: style['button-to_site'],
            onClick: function onClick() {
              return _this2.handleGoToSiteClick();
            },
            children: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0441\u0430\u0439\u0442"
          })]
        }), /*#__PURE__*/_jsxs("video", {
          loop: false,
          muted: true,
          autoPlay: true,
          className: this.state.isPlay ? style['play'] : style['paused'],
          onEnded: this.handleVideoEnd,
          ref: function ref(videoElement) {
            return _this2.video = videoElement;
          },
          children: [/*#__PURE__*/_jsx("source", {
            src: this.props.mp4,
            type: "video/mp4"
          }), /*#__PURE__*/_jsx("source", {
            src: this.props.webm,
            type: "video/webm"
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: style['button-mute'],
          onClick: this.muteChange,
          children: /*#__PURE__*/_jsx(IconMuted, {
            isMute: this.state.isMute
          })
        }), /*#__PURE__*/_jsx("div", {
          className: style['button-close'],
          onClick: this.handleClose,
          children: /*#__PURE__*/_jsx("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            children: /*#__PURE__*/_jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M2.193.78C2.113.7 1.99.696 1.91.776L.776 1.91c-.078.077-.07.21.002.283L5.585 7 .78 11.807c-.08.08-.083.204-.003.284l1.132 1.134c.076.078.21.07.282-.002L7 8.415l4.807 4.807c.08.08.204.083.284.003l1.134-1.132c.078-.077.07-.21-.002-.283L8.415 7l4.807-4.807c.08-.08.083-.204.003-.284L12.09.775c-.077-.078-.21-.07-.283.002L7 5.585 2.193.78z"
            })
          })
        })]
      });
    }
  }, {
    key: "handleReplayClick",
    value: function handleReplayClick() {
      if (this.video) {
        this.video.play().catch(function (e) {
          throw e;
        });
        this.setState({
          isPlay: true
        });
      }
    }
  }, {
    key: "handleGoToSiteClick",
    value: function handleGoToSiteClick() {
      window.open(this.props.url);
    }
  }]);
}(React.Component);